import Client from './client';

export default class PendingBankPayments extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getPending(options = {}) {
    return this.makeRequest(`${this.host}/internal/bank/payment/pending`, options);
  }

}
